import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'
import ManageService from '../ManageService/ManageService.vue'
import ManageMachineDowntime from '../ManageMachineDowntime/ManageMachineDowntime.vue'
import ManageServiceCost from '../ManageServiceCost/ManageServiceCost.vue'
import CloseServiceOrder from '../CloseServiceOrder/CloseServiceOrder.vue'
import TemplateSelect from '../../../Checklists/components/checklistTemplate/templateSelect/templateSelect.vue'
import InstitutionInactive from '../../../Institutions/components/institutionInactive/institutionInactive.vue'
import DepartmentInactive from '../../../Department/deparmentInactive/departmentInactive.vue'
import moment from 'moment'
import Vue from 'vue'
import InspectionRoutine from '../InspectionRoutineModal/index'
import ManageSupplier from '../../../Suppliers/components/ManageSupplier.vue'
import AcceptanceDocument from '../AcceptanceDocument/AcceptanceDocument.vue'

export default {
  props: {
    serviceOrderId: String,
  },

  components: {
    ManageService,
    ManageMachineDowntime,
    ManageServiceCost,
    CloseServiceOrder,
    TemplateSelect,
    InstitutionInactive,
    DepartmentInactive,
    InspectionRoutine,
    ManageSupplier,
    AcceptanceDocument,
  },

  async created() {
    try {
      Vue.$globalEvent.$emit('loader', true)
      window.scrollTo(0, 0)

      this.currentUser = JSON.parse(localStorage.getItem('user'))
      this.institution = JSON.parse(localStorage.getItem('institution'))
      this.institutionId = this.institution.id
      this.institutionInactive = this.institution.status == 1

      if (this.institution.departmentTypes.includes(1)) this.getSolutions()

      this.getInstitutions()

      if (this.institution.userType > 1) {
        this.getUserUnidades()
      } else {
        this.getUnidades()
      }

      this.getCostCenters()
      this.getSuppliers()
      this.getUsers()
      this.getAllUsers()
      this.getUsersByType()
      this.getWorkshops()
      this.getEquipments()

      if (this.serviceOrderId) {
        this.serviceOrderLoading = true
        this.getServiceOrder(this.serviceOrderId)
      }

      this.responsible = this.currentServiceOrder.responsibleName

      const called = JSON.parse(localStorage.getItem('called'))
      localStorage.removeItem('called')
      if (called) {
        this.currentServiceOrder.calledId = called.id
        this.currentServiceOrder.category = this.categories[called.category]
        this.equipmentVisible = called.category == 0 ? true : false
        this.currentCalled = called
        this.unidadeId = called.unidadeId
        this.currentServiceOrder.name = `${this.$t('Chamado Nº')} ${
          called.number
        }`
        this.currentServiceOrder.requester = called.userRequester.name
        this.requestDateTime = called.createdAt

        this.currentServiceOrder.request = called.request
        this.equipmentId = called.equipmentId
        this.departmentId = called.departmentId
        this.currentServiceOrder.subDepartmentId = called.subDepartmentId
        this.currentServiceOrder.workshopId = called.workshopId
        this.currentServiceOrder.costCenterId = called.costCenterId
        setTimeout(() => {
          if (called.equipment) {
            this.querySelectionsEquipment(called.equipment.identification)
          }

          const equip = this.equipments.find((x) => x.id == this.equipmentId)
          if (equip) {
            const isInWarranty = moment().isBefore(
              moment(equip.warrantyEndDate, 'yyyy-MM-DD')
            )
            if (isInWarranty) {
              this.$toast('O equipamento selecionado está na garantia!')
            }
          }
        }, 2000)
      }

      if (
        this.institution.userType > 2 &&
        this.institution.userType != 8 &&
        !this.currentServiceOrder.responsibleName
      ) {
        this.currentServiceOrder.responsibleName = this.currentUser.name
      }

      if (this.$route.query.equipmentId) {
        this.equipmentId = parseInt(this.$route.query.equipmentId)

        if (this.$route.query.type) {
          this.currentServiceOrder.serviceOrderType = this.$route.query.type
          this.changeRequest(this.$route.query.type)
        }

        setTimeout(() => {
          const equip = this.equipments.find((x) => x.id == this.equipmentId)
          if (equip) {
            this.querySelectionsEquipment(equip.identification)
            const isInWarranty = moment().isBefore(
              moment(equip.warrantyEndDate, 'yyyy-MM-DD')
            )
            if (isInWarranty) {
              this.$toast('O equipamento selecionado está na garantia!')
            }
          }
        }, 2000)
      }

      console.log(this.$route.query)
      if (this.$route.query.fromPlanning === 'true') {
        console.log('this.$route.query')

        this.currentServiceOrder.name = 'Módulo agendamento'

        const planningOSInfoRaw = localStorage.getItem(
          `planningOSInfo-${this.$route.query.planningId}`
        )
        console.log('planningOSInfoRaw', planningOSInfoRaw)
        if (planningOSInfoRaw) {
          const planningOSInfo = JSON.parse(planningOSInfoRaw)
          if (planningOSInfo.serviceOrderName) {
            this.currentServiceOrder.name = planningOSInfo.serviceOrderName
          }
          if (planningOSInfo.responsibleId) {
            this.currentServiceOrder.responsibleId =
              planningOSInfo.responsibleId
          }
          if (planningOSInfo.responsibleName) {
            this.currentServiceOrder.responsibleName =
              planningOSInfo.responsibleName
          }
          if (planningOSInfo.requester) {
            this.currentServiceOrder.requester = planningOSInfo.requester
          }
          if (planningOSInfo.responsability) {
            this.currentServiceOrder.isExternal =
              planningOSInfo.responsability == 'Externa' ? true : false
          }
          if (planningOSInfo.requestDescription) {
            this.currentServiceOrder.request = planningOSInfo.requestDescription
          }
          localStorage.removeItem('planningOSInfo')
        } else if (
          localStorage.getItem(`planningOSInfo-${this.$route.query.planningId}`)
        ) {
          const info = JSON.parse(localStorage.getItem('planningOSInfo'))
          if (info.responsability) {
            this.currentServiceOrder.responsability = info.responsability
          }
          localStorage.removeItem('planningOSInfo')
        }

        if (this.$route.query.scheduledDate && this.$route.query.year) {
          const scheduledDate = this.$route.query.scheduledDate
          const year = this.$route.query.year
          const [day, month] = scheduledDate.split('/')
          const dateStr = `${year}-${month.padStart(2, '0')}-${day.padStart(
            2,
            '0'
          )}T00:00:00`
          this.requestDateTime = dateStr
        }
      }

      sessionStorage.clear()
      Vue.$globalEvent.$emit('loader', false)
    } catch (error) {
      Vue.$globalEvent.$emit('loader', false)
    }
  },

  data() {
    return {
      formValid: false,
      acceptanceDialog: false,
      unarchiveLoading: false,
      printLoading: false,
      serviceOrderLoading: false,
      responsible: '',
      institution: {},
      location: '',
      expandedServices: [],
      expandedDowntimes: [],
      expandedServicesCosts: [],
      searchEquipment: null,
      searchEquipmentPropertyCode: null,
      step: 0,
      selectedRequestTab: 0,
      selectedAttendTab: 0,
      errorMessage: '',
      disabled: false,
      calledRemove: false,
      loading: false,
      supplierLoading: false,
      institutionLoading: false,
      unidadeLoading: false,
      equipmentLoading: false,
      servicesLoading: false,
      machineDowntimesLoading: false,
      serviceOrderCostsLoading: false,
      checklistTemplateLoading: false,
      printChecklistLoading: false,
      departmentLoading: false,
      costCenterLoading: false,
      firstValid: true,
      alterDialog: false,
      supplierDialog: false,
      serviceDialog: false,
      downtimeDialog: false,
      costDialog: false,
      editServiceDialog: false,
      editDowntimeDialog: false,
      editCostDialog: false,
      removeDialog: false,
      closeServiceOrderDialog: false,
      signatureErrorDialog: false,
      activeOstemplateDialog: false,
      inactiveOsTemplateDialog: false,
      templateSelectDialog: false,
      notCalibrationDialog: false,
      deleteDialog: false,
      dialogKey: false,
      newChecklist: false,
      changedData: false,
      deleteService: false,
      deleteDowntime: false,
      deleteCost: false,
      isEditing: false,
      error: false,
      serviceOrderClosing: false,
      institutionInactive: false,
      departmentInactive: false,
      equipmentVisible: true,
      newService: false,
      newDowntime: false,
      showSuplier: false,
      withoutValues: false,
      requestDateTimeError: false,
      attendDateTimeError: false,
      requestDateTime: null,
      attendDateTime: null,
      currentCalled: null,
      tab: null,
      users: [],
      checklistId: null,
      institutionId: null,
      institutions: [],
      unidadeId: null,
      unidades: [],
      costCenterId: null,
      costCenters: [],
      departmentId: null,
      departments: [],
      supplierId: null,
      suppliers: [],
      equipmentId: null,
      equipments: [],
      equipmentsFiltered: [],
      equipmentSelected: {},
      serviceId: null,
      services: [],
      serviceOrderCostsId: null,
      serviceOrderCosts: [],
      machineDowntimeId: null,
      machineDowntimes: [],
      departmentName: null,
      costCenterName: null,
      textRemove: null,
      currentService: {},
      currentServiceCost: {},
      currentMachineDowntime: {},
      currentUser: {},
      checklistTemplates: [],
      checklistTemplateId: null,
      templateItems: [],
      uploadDocuments: [],
      calibrations: [],
      workshopTypesOriginal: [
        { text: 'Engenharia Clínica', value: 0 },
        { text: 'Carpintaria', value: 1 },
        { text: 'Elétrica', value: 2 },
        { text: 'Hidráulica', value: 3 },
        { text: 'Climatização', value: 4 },
        { text: 'Gasoterapia', value: 5 },
        { text: 'Zeladoria', value: 6 },
        { text: 'Vidraçaria', value: 7 },
        { text: 'Mecânica', value: 8 },
        { text: 'Serralheria', value: 9 },
        { text: 'Predial Civil', value: 10 },
        { text: 'Pintura Predial', value: 11 },
        { text: 'Pintura Industrial', value: 12 },
      ],
      workshopTypes: [
        { text: 'Engenharia Clínica', value: 0 },
        { text: 'Carpintaria', value: 1 },
        { text: 'Elétrica', value: 2 },
        { text: 'Hidráulica', value: 3 },
        { text: 'Climatização', value: 4 },
        { text: 'Gasoterapia', value: 5 },
        { text: 'Zeladoria', value: 6 },
        { text: 'Vidraçaria', value: 7 },
        { text: 'Mecânica', value: 8 },
        { text: 'Serralheria', value: 9 },
        { text: 'Predial Civil', value: 10 },
        { text: 'Pintura Predial', value: 11 },
        { text: 'Pintura Industrial', value: 12 },
      ],
      serviceOrderInternalTypes: [
        'Treinamento',
        'Segurança elétrica',
        'Preventiva',
        'Instalação',
        'Rotina de Inspeção',
        'Corretiva',
        'Calibração',
        'Validação/Qualificação',
        'Serviço Administrativo',
        'Empréstimo',
      ],
      causeDefects: [
        'Não aplicável',
        'Falha intrínseca',
        'Falha infraestrutura',
        'Erro operacional',
        'Dano acidental',
        'Abuso na utilização',
      ],
      statusStep: [
        'Manutenção terceirizada in loco',
        'Manutenção terceirizada externa',
        'Manutenção interna',
        'Aguardando peça',
        'Aguardando orçamento',
        'Aguardando avaliação externa',
        'Aguardando aprovação de orçamento',
        'Aguardando liberação do setor',
        'Deslocamento',
        'Equipamento não encontrado',
        'Aguardando Solicitação/Ordem de Compra',
      ],
      costTypes: ['Custo material', 'Custo serviços', 'Custo evitado'],
      categories: ['Equipamento', 'Setor'],
      currentServiceOrder: {
        id: 0,
        name: '',
        serviceOrderType: null,
        number: '',
        requester: '',
        requestDateTime: null,
        attendDateTime: null,
        request: '',
        causeDefect: null,
        isExternal: false,
        isTecnovigilanciaAlert: false,
        category: 'Equipamento',
        costCenterId: null,
      },
      nameRules: [
        (v) => !!v || this.$t('Nome da O.S. requerido'),
        (v) =>
          v.length <= 128 || 'Nome da O.S. deve ter no máximo 128 caracteres',
      ],
      institutionRules: [(v) => !!v || 'Instituição é requerida'],
      unidadeRules: [(v) => !!v || 'Unidade é requerida'],
      typeOsRules: [(v) => (v != -1 && !!v) || 'Tipo da O.S. é requerida'],
      requestDateTimeRules: [(v) => !!v || 'Data da solicitação é requerida'],
      requesterRules: [
        (v) => !!v || 'Solicitante é requerido',
        (v) =>
          v.length <= 128 || 'Solicitante deve ter no máximo 128 caracteres',
      ],
      requestRules: [
        (v) =>
          v == null ||
          v.length <= 1000 ||
          'Solicitação/Reclamação deve ter no máximo 1000 caracteres',
      ],
      apiService: new ApiService(),
      headersServices: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Data e hora início',
          align: 'center',
          value: 'dateTimeStartStep',
        },
        {
          text: 'Data e hora fim',
          align: 'center',
          value: 'dateTimeEndStep',
        },
        {
          text: 'Estado O.S.',
          align: 'center',
          value: 'statusStepServiceOrder',
        },
        {
          text: 'Tempo',
          align: 'center',
          value: 'timeSpent',
          sortable: false,
        },
        {
          text: 'Responsável',
          align: 'center',
          value: 'user',
          sortable: false,
        },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
        },
      ],
      headersServicesMobile: [
        {
          text: 'Estado O.S.',
          align: 'center',
          value: 'status',
        },
        {
          text: 'Ações',

          value: 'actions',
          align: 'center',
          sortable: false,
        },
      ],
      headersMachineDowntime: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Data hora parada',
          align: 'center',
          value: 'stoppedDateTime',
        },
        {
          text: 'Data hora retorno',
          align: 'center',
          value: 'returnDateTime',
        },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
        },
      ],
      headersMachineDowntimeMobile: [
        {
          text: 'Data hora parada',
          align: 'center',

          value: 'stoppedDateTime',
        },
        {
          text: 'Data hora retorno',
          align: 'center',

          value: 'returnDateTime',
        },
      ],
      headersServiceOrderCost: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Nº Nota',
          align: 'center',
          value: 'invoice',
        },
        {
          text: 'Tipo custo',
          align: 'center',
          value: 'costType',
        },
        {
          text: 'Custo',
          align: 'center',
          value: 'cost',
        },
        {
          text: 'Fornecedor',
          align: 'center',
          value: 'supplier',
          sortable: false,
        },
        {
          text: 'Data',
          align: 'center',
          value: 'costDate',
          sortable: false,
        },
        {
          text: 'Descrição',
          align: 'center',
          value: 'description',
          sortable: false,
        },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
        },
      ],
      headersServiceOrderCostMobile: [
        {
          text: 'Custo',
          align: 'center',
          value: 'cost',
        },
        {
          text: 'Fornecedor',
          align: 'center',
          value: 'supplier',
        },
      ],
      searchEquipmentSerial: '',
      responsibleUsers: [],
      allUsers: [],
      solutionLoading: false,
      solutions: [],
      inpectionRoutine: false,
      orderId: null,
      orderKey: false,
      totalCost: 0,
      Document: false,
    }
  },

  computed: {
    buttonText() {
      return this.isEditing ? 'Atualizar' : 'Adicionar'
    },
    subDepartments() {
      const department = this.departments.find(
        (x) =>
          x.id == this.departmentId ||
          (this.equipmentSelected &&
            x.id == this.equipmentSelected.departmentId)
      )
      return department ? department.subDepartments : []
    },
  },

  methods: {
    getRowClass(item) {
      return item.id === this.highlightedServiceId
        ? 'highlighted-service-row'
        : ''
    },

    openCalibrationV2() {
      const route = this.$router.resolve({
        path:
          this.currentServiceOrder.calibrationsV2.length > 0
            ? '/calibration/v2/manage?id=' +
              this.currentServiceOrder.calibrationsV2[0].id
            : '/calibration/v2/manage?orderId=' + this.currentServiceOrder.id,
      })
      window.open(route.href, '_blank')
    },

    async hasDocument() {
      await this.apiService
        .get(`Acceptance/checkHasDocument?id=${this.currentServiceOrder.id}`)
        .then((response) => {
          if (response.statusCode === 200) {
            this.Document = true
          } else {
            this.Document = false
          }
        })
        .catch((error) => {
          if (error.response && error.response.statusCode === 404) {
            this.Document = false
          }
        })
    },
    openAcceptanceDialog() {
      this.acceptanceDialog = true
    },

    closeAcceptanceDialog() {
      this.acceptanceDialog = false
      this.getServiceOrder(this.serviceOrderId)
    },

    async generatePDF() {
      const route = this.$router.resolve({
        path: `/printServiceOrder/${this.institutionId}/${this.currentServiceOrder.id}`,
      })
      window.open(route.href, '_blank')
    },

    openElectricalSafety(currentServiceOrder) {
      sessionStorage.clear()
      this.currentServiceOrder = currentServiceOrder
      sessionStorage.setItem(
        'serviceOrder',
        JSON.stringify(this.currentServiceOrder)
      )
      window.open('/formElectricalSafety', '_blank').focus()
    },
    previewElectricalSafetyChecklistPDF(serviceOrder) {
      const checklistId = serviceOrder.arkMedsChecklist.id
      this.$router.push({
        name: 'ElectricalSafetyPreview',
        params: { id: checklistId },
      })
    },
    async generateElectricalSafetyChecklistPDF(serviceOrder) {
      try {
        const checklistId = serviceOrder.arkMedsChecklist.id
        const response = await this.apiService.post(
          `arkmeds/webhooks/generateElectricalSafetyPdf/${checklistId}`
        )

        if (response.statusCode === 200) {
          const pdfBase64 = response.message

          const pdfUrl = `data:application/pdf;base64,${pdfBase64}`
          const link = document.createElement('a')
          link.href = pdfUrl
          link.setAttribute(
            'download',
            `Checklist_${this.formatDate(new Date())}.pdf`
          )
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          this.$toast.success('PDF gerado com sucesso!')
        } else {
          this.$toast.error('Falha ao gerar o PDF.')
        }
      } catch (error) {
        console.error('Erro ao gerar PDF:', error)
        this.$toast.error('Erro ao gerar o PDF.')
      }
    },

    async getWorkshops() {
      await this.apiService
        .get('workshop/' + this.institution.id, true, false)
        .then((response) => {
          this.workshopTypes = response.content
        })
    },

    openInspectionRoutine(item) {
      this.orderId = item.id
      this.orderKey = !this.orderKey
      this.inpectionRoutine = true
    },

    getCost(cost) {
      if (cost.costType == 0) {
        if (cost.costValue) {
          return cost.costValue.toInstLocale()
        } else if (cost.stockExit && cost.stockExit.totalValue) {
          return cost.stockExit.totalValue.toInstLocale()
        }
        return this.$t('Sem registros')
      } else {
        return cost.costValue.toInstLocale()
      }
    },

    getNf(cost) {
      if (cost.invoiceNumber) {
        return cost.invoiceNumber
      } else {
        return 'Ver estoque'
      }
    },

    async getUserUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(
          `unidade/listByUserAndInstitution/${this.institutionId}`,
          true,
          false
        )
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    changeRequest(event) {
      if (
        this.currentServiceOrder.request == '' ||
        this.currentServiceOrder.request == null
      ) {
        switch (event) {
          case 'Preventiva':
            this.currentServiceOrder.request =
              'Execução da manutenção preventiva.'
            break
          case 'Calibração':
            this.currentServiceOrder.request = 'Execução de calibração.'
            break
          case 'Segurança elétrica':
            this.currentServiceOrder.request =
              'Execução do teste de segurança elétrica.'
            break
          case 'Treinamento':
            this.currentServiceOrder.request = 'Execução de treinamento.'
            break
          case 'Validação/Qualificação':
            this.currentServiceOrder.request =
              'Execução de validação/qualificação. '
            break
        }
      }
    },

    close() {
      sessionStorage.clear()
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$router.push('/serviceOrders')
      }
    },

    async closeDialog() {
      if (this.supplierDialog) {
        this.supplierDialog = false
        await this.getSuppliers()
        await this.getServiceOrder(this.currentServiceOrder.id)
      } else if (this.serviceDialog) {
        this.serviceDialog = false
        await this.getServices()
      } else if (this.downtimeDialog) {
        this.downtimeDialog = false
        await this.getMachineDowntimes()
        await this.getServiceOrder(this.currentServiceOrder.id)
      } else if (this.costDialog) {
        this.costDialog = false
        await this.getServiceOrderCosts()
        await this.getTotalCost()
        await this.getServiceOrder(this.currentServiceOrder.id)
      } else if (this.editServiceDialog) {
        this.editServiceDialog = false
        this.getServices()
      } else if (this.editDowntimeDialog) {
        this.editDowntimeDialog = false
        await this.getMachineDowntimes()
        await this.getServiceOrder(this.currentServiceOrder.id)
      } else if (this.editCostDialog) {
        this.editCostDialog = false
        await this.getServiceOrderCosts()
        await this.getTotalCost()
        await this.getServiceOrder(this.currentServiceOrder.id)
      } else if (this.closeServiceOrderDialog) {
        this.closeServiceOrderDialog = false
      } else if (this.templateSelectDialog) {
        this.templateSelectDialog = false
        this.$router.go(-1)
      } else {
        this.changedData = false
        await this.close()
      }

      this.costDialog = false
    },

    addSupplier() {
      this.dialogKey = !this.dialogKey
      this.supplierDialog = true
    },

    addService() {
      if (!this.isEditing && this.currentServiceOrder.id == 0) {
        this.newService = true
        this.submit()
      }

      if (this.$refs.firstForm.validate() || this.isEditing) {
        this.dialogKey = !this.dialogKey
        this.serviceDialog = true
      }
    },

    editService(service) {
      this.currentService = service
      this.editServiceDialog = true
      this.dialogKey = !this.dialogKey
    },

    removeService(service) {
      this.currentService = service
      this.textRemove = 'o serviço'
      this.removeDialog = true
      this.deleteService = true
    },

    addDowntime() {
      if (!this.isEditing && this.currentServiceOrder.id == 0) {
        this.newDowntime = true
        this.submit()
      }

      if (this.$refs.firstForm.validate()) {
        this.dialogKey = !this.dialogKey
        this.downtimeDialog = true
      }
    },

    editMachineDowntime(downtime) {
      this.currentMachineDowntime = downtime
      this.editDowntimeDialog = true
      this.dialogKey = !this.dialogKey
    },

    removeMachineDowntime(downtime) {
      this.currentMachineDowntime = downtime
      this.textRemove = 'a hora parada'
      this.removeDialog = true
      this.deleteDowntime = true
    },

    addCost() {
      this.dialogKey = !this.dialogKey
      this.costDialog = true
    },

    editCost(cost) {
      this.currentServiceCost = cost
      this.editCostDialog = true
      this.dialogKey = !this.dialogKey
    },

    removeCost(cost) {
      this.currentServiceCost = cost
      this.textRemove = 'o custo'
      this.removeDialog = true
      this.deleteCost = true
    },

    openChecklist() {
      if (
        this.currentServiceOrder.status == 0 &&
        this.currentServiceOrder.checklistTemplateId != null &&
        this.currentServiceOrder.checklists.length > 0
      ) {
        this.activeOstemplateDialog = true
      } else if (
        this.currentServiceOrder.status == 1 &&
        this.currentServiceOrder.checklistTemplateId != null &&
        this.currentServiceOrder.checklists.length > 0
      ) {
        this.inactiveOsTemplateDialog = true
      } else if (
        this.departmentInactive &&
        this.currentServiceOrder.checklistTemplateId != null &&
        this.currentServiceOrder.checklists.length > 0
      ) {
        this.inactiveOsTemplateDialog = true
      } else {
        this.openTemplateSelect()
      }
    },

    openTemplateSelect() {
      this.newChecklist = true
      this.activeOstemplateDialog = false
      this.templateSelectDialog = true
      this.dialogKey = !this.dialogKey
    },

    openEquipment() {
      if (this.equipmentId) {
        const route = this.$router.resolve({
          path: `/editEquipment/${this.equipmentId}`,
        })
        window.open(route.href, '_blank')
      }
    },

    viewChecklist() {
      const checklist = this.currentServiceOrder.checklists[0]
      const checklistServiceOrder = {
        ServiceOrderId: checklist.serviceOrderId,
        ChecklistId: checklist.id,
        isValidatorSigned: checklist.isValidatorSigned,
        EquipmentId: checklist.equipmentId,
      }
      sessionStorage.setItem('checklist', JSON.stringify(checklistServiceOrder))
      sessionStorage.setItem(
        'serviceOrder',
        JSON.stringify(this.currentServiceOrder)
      )
      this.$router.push('/formChecklist')
    },

    categorySelected() {
      this.equipmentVisible =
        this.categories.indexOf(this.currentServiceOrder.category) == 0
      if (!this.isEditing) {
        this.unidadeId = null
        this.departmentId = null
      }
      this.equipmentId = null
      this.equipmentSelected = {}
    },

    async generateChecklistPDF() {
      const checklist = this.currentServiceOrder.checklists[0]
      const route = this.$router.resolve({
        path: `/printChecklist/${checklist.id}`,
      })
      window.open(route.href, '_blank')
    },

    uploadDocument() {
      sessionStorage.clear()
      const order = {
        id: this.currentServiceOrder.id,
        number: this.currentServiceOrder.number,
      }
      sessionStorage.setItem('serviceOrder', JSON.stringify(order))
      const routeData = this.$router.resolve({ path: '/uploadDocument' })
      window.open(routeData.href, '_blank')
    },

    async closingServiceOrder() {
      await this.getServiceOrder()

      const servicesWithoutEnd = this.services.find((x) => !x.dateTimeEndStep)

      if (servicesWithoutEnd) {
        this.$toast.warning(
          'Existem etapas sem data e hora fim associadas, conclua as etapas para prosseguir com fechamento da O.S.'
        )
        return
      }

      if (this.currentServiceOrder.isValidatorSigned) {
        this.$toast.warning(
          'Remova a validação da ordem de serviço para prosseguir com o cancelamento do fechamento'
        )
        return
      }

      if (this.currentServiceOrder.status == 0) {
        this.serviceOrderClosing = true
        if (this.$refs.firstForm.validate() && this.attendDateTime) {
          this.submit()
        } else {
          this.$refs.firstForm.$el.scrollIntoView({ behavior: 'smooth' })
          this.attendDateTimeError = this.attendDateTime == null
        }
      } else {
        this.cancelClosing()
      }
    },

    async getUsersByType() {
      await this.apiService
        .get(`user/byType/${this.institutionId}`, null, true, false)
        .then((response) => {
          this.responsibleUsers = response.content
        })
    },

    async getUsers() {
      await this.apiService
        .get(`user/list/${this.institutionId}`, null, true, false)
        .then((response) => {
          this.users = response.content
        })
    },

    async getAllUsers() {
      await this.apiService
        .get(`user/listAll`, null, true, false)
        .then((response) => {
          this.allUsers = response.content
        })
    },

    getUserName(userId) {
      const user = this.allUsers.find((user) => user.id == userId)

      if (user) return user.name
    },

    getSupplierName(supplierId) {
      if (!supplierId) return 'Sem registro'

      return this.suppliers.find((supplier) => supplier.id == supplierId).name
    },

    checkStatusStep() {
      const statusStep = this.services.map(
        (service) => service.statusStepServiceOrder
      )
      this.currentServiceOrder.isEditing =
        statusStep.includes(0) ||
        statusStep.includes(1) ||
        statusStep.includes(5)
      this.showSuplier =
        statusStep.includes(0) ||
        statusStep.includes(1) ||
        statusStep.includes(5)
    },

    signServiceOrder() {
      if (this.currentUser.signatureImage) {
        this.currentServiceOrder.isExecutingSigned = true
        this.currentServiceOrder.executingUserId = this.currentUser.id
        this.submit()
      } else {
        this.signatureErrorDialog = true
      }
    },

    validateServiceOrder() {
      if (this.currentUser.signatureImage) {
        this.currentServiceOrder.isValidatorSigned = true
        this.currentServiceOrder.validatorUserId = this.currentUser.id
        this.submit()
      } else {
        this.signatureErrorDialog = true
      }
    },

    async getCalibrations() {
      this.apiService
        .get('serviceOrder/calibration/${this.serviceOrderId}')
        .then((response) => {
          this.currentServiceOrder.calibrations = response.content
        })
    },

    async getServiceOrder(serviceOrderId) {
      try {
        const response = await this.apiService.get(
          `serviceOrder/getServiceOrder/${this.institutionId}/${serviceOrderId}`,
          null,
          true,
          true
        )

        const serviceOrder = response.content
        this.isEditing = true

        const currentResponsible =
          this.currentServiceOrder.responsibleName || ''

        if (serviceOrder.serviceOrderType === 6) {
          await this.getCalibrations()
        }

        this.currentServiceOrder = {
          ...serviceOrder,
          responsibleName: serviceOrder.responsibleName || currentResponsible,
          number: String(serviceOrder.number).padStart(3, '0'),
          request: serviceOrder.request || '',
          serviceOrderType:
            this.serviceOrderInternalTypes[serviceOrder.serviceOrderType],
          causeDefect: this.causeDefects[serviceOrder.causeDefect],
          category: this.categories[serviceOrder.category],
        }

        this.location = serviceOrder.location
        this.equipmentId = serviceOrder.equipmentId
        this.costCenterId = serviceOrder.costCenterId
        this.unidadeId = serviceOrder.unidadeId
        this.requestDateTime = serviceOrder.dateTimeRequest
        this.attendDateTime = serviceOrder.dateTimeAttend
        this.supplierId = serviceOrder.supplierId
        this.checklistTemplateId = serviceOrder.checklistTemplateId
        this.uploadDocuments = serviceOrder.uploadDocuments
        this.calibrations = serviceOrder.calibrations

        if (this.equipmentId) {
          await this.getEquipmentById()
        }

        if (this.equipmentSelected?.alienated) {
          this.equipments.unshift(this.equipmentSelected)
        }

        this.getCalled()

        if (serviceOrder.checklistServiceOrders.length > 0) {
          this.checklistId = serviceOrder.checklistServiceOrders[0].checklistId
        }

        this.departmentInactive = serviceOrder.department?.status === 1

        if (serviceOrder.category === 'Setor' || serviceOrder.category === 1) {
          this.departmentId = serviceOrder.departmentId
          this.categorySelected()
        } else {
          this.querySelectionsEquipment(this.equipmentSelected.identification)
        }

        await this.getSolutions()

        this.disabled =
          this.institution.userType === 4 || this.institution.userType === 5

        this.serviceOrderLoading = false

        await Promise.all([
          this.getServices(),
          this.getServiceOrderCosts(),
          this.getMachineDowntimes(),
        ])
      } catch (err) {
        if (err.status === 404) {
          this.$router.push('/serviceOrders')
        }
        this.serviceOrderLoading = false
      }
    },

    confirmDowntime() {
      this.getMachineDowntimes()
      this.editDowntimeDialog = false
      this.downtimeDialog = false
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService
        .get('institution/list', null, true, false)
        .then((response) => {
          this.institutions = response.content
          this.institutionLoading = false
        })
    },

    async getSolutions() {
      this.solutionLoading = true

      const model = {
        id: this.institutionId,
        workshopId: this.currentServiceOrder.workshopId,
      }
      await this.apiService
        .post(`defectSolution/workshop`, model)
        .then((response) => {
          this.solutions = response.content
          this.solutionLoading = false
        })
    },

    unarchive() {
      this.unarchiveLoading = true
      this.apiService
        .get('serviceOrder/unarchive/' + this.currentServiceOrder.id)
        .then((response) => {
          this.currentServiceOrder.isArchived = false
          this.unarchiveLoading = false
          this.$toast.success('Ordem de serviço desarquivada com sucesso!')
        })
        .catch(() => {
          this.unarchiveLoading = false
        })
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`, null, true, false)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getCostCenters() {
      this.costCenterLoading = true

      if (!this.unidadeId) {
        this.costCenters = []
        this.costCenterLoading = false
        return
      }

      await this.apiService
        .get(
          `costCenter/listActiveByUnidade/${this.institutionId}/${this.unidadeId}`,
          null,
          true,
          false
        )
        .then((response) => {
          this.costCenters = response.content
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.costCenterLoading = false
    },

    async getDepartments() {
      this.departmentLoading = true

      await this.apiService
        .get(`department/list/unidade/${this.unidadeId}`, null, true, false)
        .then((response) => {
          this.departments = response.content
          this.departmentLoading = false
        })
        .catch(() => {
          this.departmentLoading = false
        })
    },

    async getSuppliers() {
      this.supplierLoading = true

      await this.apiService
        .get(`supplier/list/${this.institutionId}`, null, true, false)
        .then((response) => {
          this.suppliers = response.content
          this.supplierLoading = false
        })
    },

    async getEquipments() {
      this.equipmentLoading = true

      await this.apiService
        .get(`equipment/list/general/${this.institutionId}`, null, true, false)
        .then((response) => {
          this.equipments = response.content.filter((x) => x.alienated == false)
          this.equipmentsFiltered = this.equipments
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.equipmentLoading = false
    },

    async getServices() {
      this.servicesLoading = true
      await this.apiService
        .get(`service/list/${this.currentServiceOrder.id}`, null, true, false)
        .then((response) => {
          this.services = response.content
          this.currentServiceOrder.services = this.services
          this.checkStatusStep()
          this.servicesLoading = false
          this.hasDocument()
        })
    },

    async getTotalCost() {
      await this.apiService
        .get(
          `serviceOrderCost/sumcosts/${this.currentServiceOrder.id}`,
          null,
          true,
          false
        )
        .then((response) => {
          this.totalCost = response.content.totalCost
        })
        .catch((error) => {
          console.error('Erro ao buscar o custo total', error)
        })
    },

    async getServiceOrderCosts() {
      this.servicesLoading = true
      await this.apiService
        .get(
          `serviceOrderCost/list/${this.currentServiceOrder.id}`,
          null,
          true,
          false
        )
        .then((response) => {
          this.serviceOrderCosts = response.content
          this.servicesLoading = false
        })
    },

    async getMachineDowntimes() {
      this.machineDowntimesLoading = true
      await this.apiService
        .get(
          `machineDowntime/list/${this.currentServiceOrder.id}`,
          null,
          true,
          false
        )
        .then((response) => {
          this.machineDowntimes = response.content
          this.machineDowntimesLoading = false
        })
    },

    async getChecklistTemplate() {
      if (this.equipmentSelected == null) return

      this.checklistTemplateLoading = true

      const templateModel = {
        StandardEquipmentId: this.equipmentSelected.standardEquipmentId,
        InstitutionId: this.institutionId,
      }

      await this.apiService
        .post(
          `checklistTemplate/listByEquipment`,
          templateModel,
          null,
          true,
          false
        )
        .then((response) => {
          this.checklistTemplates = response.content
          this.checklistTemplateLoading = false
        })
    },

    async getTemplateItems() {
      const checklistTemplate = this.checklistTemplates.filter(
        (x) => x.id == this.checklistTemplateId
      )[0].checklistTemplate
      this.templateItems = checklistTemplate.templateItems
    },

    async getCalled() {
      await this.apiService
        .get(
          `called/getCalled/${this.currentServiceOrder.id}`,
          null,
          true,
          false
        )
        .then((response) => {
          if (response.content) {
            this.currentCalled = response.content
          } else {
            this.calledRemove = true
          }
        })
    },

    async openCalled() {
      await this.getCalled()
      let routeData = this.$router.resolve({
        path: `/editCalled/${this.currentCalled.id}`,
      })
      window.open(routeData.href, '_blank')
    },

    openCalibration() {
      sessionStorage.clear()
      const order = { ...this.currentServiceOrder }
      order.department = null
      order.executingUser = null
      order.services = null
      order.unidade = null
      sessionStorage.setItem('serviceOrder', JSON.stringify(order))
      this.$router.push({ path: '/formCalibration' })
    },

    async openCertified() {
      if (this.calibrations.length > 0) {
        const calibration = this.calibrations[0]
        const route = this.$router.resolve({
          path: `/printCalibrationCertified/${this.institutionId}/${calibration.id}`,
        })
        window.open(route.href, '_blank')
      } else {
        this.notCalibrationDialog = true
        setTimeout(() => {
          this.notCalibrationDialog = false
        }, 3000)
      }
    },

    async openCertifiedV2() {
      if (this.currentServiceOrder.calibrationsV2.length > 0)
        this.$router.push(
          '/calibration/v2/print?id=' +
            this.currentServiceOrder.calibrationsV2[0].id
        )
      else
        this.$router.push(
          '/calibration/v2/manage?orderId=' + this.currentServiceOrder.id
        )
    },

    validateDates() {
      const requestDate = this.requestDateTime
      const attendDate = this.attendDateTime

      let valid = true

      if (
        !!requestDate &&
        !!attendDate &&
        moment(requestDate).isAfter(moment(attendDate))
      ) {
        this.$toast.warning(
          this.$t(
            'A data de atendimento não pode ser antes da data de solicitação'
          )
        )
        valid = false
      }

      return valid
    },

    async submit() {
      this.loading = true
      if (
        this.$refs.firstForm.validate() &&
        this.$refs.formSupplier.validate() &&
        this.requestDateTime
      ) {
        if (this.validateDates()) {
          const serviceOrder = {
            calledId: this.currentServiceOrder.calledId,
            ResponsibleName: this.currentServiceOrder.responsibleName,
            Id: this.currentServiceOrder.id,
            Name: this.currentServiceOrder.name,
            InstitutionId: this.institutionId,
            location: this.location,
            UnidadeId: this.unidadeId,
            SubDepartmentId: this.currentServiceOrder.subDepartmentId,
            DepartmentId: this.departmentId,
            CostCenterId: this.costCenterId,
            workshopType: this.currentServiceOrder.workshopType,
            isExternal: this.currentServiceOrder.isExternal,
            isTecnovigilanciaAlert:
              this.currentServiceOrder.isTecnovigilanciaAlert,
            internalTeam: this.currentServiceOrder.internalTeam,
            defectSolutionId: this.currentServiceOrder.defectSolutionId,
            ServiceOrderType: this.serviceOrderInternalTypes.indexOf(
              this.currentServiceOrder.serviceOrderType
            ),
            Requester: this.currentServiceOrder.requester,
            DateTimeRequest: Utils.nowDatetimeFormat(this.requestDateTime),
            DateTimeAttend:
              this.attendDateTime != null
                ? Utils.nowDatetimeFormat(this.attendDateTime)
                : null,
            Request: this.currentServiceOrder.request,
            EquipmentId: this.equipmentId,
            CauseDefect: this.currentServiceOrder.causeDefect
              ? this.causeDefects.indexOf(this.currentServiceOrder.causeDefect)
              : null,
            SupplierId: this.supplierId,
            ChecklistTemplateId: this.checklistTemplateId,
            isExecutingSigned: this.currentServiceOrder.isExecutingSigned,
            ExecutingUserId: this.currentServiceOrder.executingUserId,
            isValidatorSigned: this.currentServiceOrder.isValidatorSigned,
            ValidatorUserId: this.currentServiceOrder.validatorUserId,
            IsProactive: this.currentServiceOrder.isProactive,
            Category: this.categories.indexOf(
              this.currentServiceOrder.category
            ),
            CloseServiceOrderDateTime:
              this.currentServiceOrder.closeServiceOrderDateTime,
            EmailForEvaluation: this.currentServiceOrder.emailForEvaluation,
            workshopId: this.currentServiceOrder.workshopId,
            costCenterId: this.currentServiceOrder.costCenterId,
            planningId: this.$route.query.planningId,
          }

          let url = 'serviceOrder/add'

          if (this.isEditing || serviceOrder.Id) {
            url = 'serviceOrder/edit'
          }

          await this.apiService
            .post(url, serviceOrder)
            .then(async (response) => {
              if (this.newService || this.newDowntime) {
                // this.currentServiceOrder = response.content;
                this.currentServiceOrder.id = response.content.id
                this.currentServiceOrder.category =
                  this.categories[response.content.category]
                this.currentServiceOrder.serviceOrderType =
                  this.serviceOrderInternalTypes[
                    response.content.serviceOrderType
                  ]
                this.newService = false
                this.newDowntime = false
              } else if (this.serviceOrderClosing) {
                this.currentServiceOrder.supplierId =
                  response.content.supplierId
                this.currentServiceOrder.emailForEvaluation =
                  this.currentCalled != null
                    ? this.currentCalled.userRequester.email
                    : null
                this.closeServiceOrderDialog = true
                this.serviceOrderClosing = false
              } else {
                this.changedData = false

                if (this.isEditing) {
                  this.$toast.success('Ordem de serviço atualizada!')
                  try {
                    Vue.$globalEvent.$emit('loader', true)
                    window.scrollTo(0, 0)

                    this.currentUser = JSON.parse(localStorage.getItem('user'))
                    const institution = JSON.parse(
                      localStorage.getItem('institution')
                    )
                    this.institution = institution
                    this.institutionId = institution.id
                    this.institutionInactive = institution.status == 1

                    this.getInstitutions()

                    if (this.institution.userType > 1) {
                      this.getUserUnidades()
                    } else {
                      this.getUnidades()
                    }

                    this.getCostCenters()
                    this.getSuppliers()
                    this.getUsers()
                    this.getAllUsers()
                    this.getUsersByType()
                    this.getCostCenters()
                    this.getSuppliers()
                    this.getUsers()
                    this.getAllUsers()
                    this.getWorkshops()
                    this.getEquipments()

                    if (this.serviceOrderId) {
                      this.serviceOrderLoading = true
                      this.getServiceOrder(this.serviceOrderId)
                    }

                    this.responsible = this.currentServiceOrder.responsibleName

                    if (
                      this.institution.userType > 2 &&
                      !this.currentServiceOrder.responsibleName
                    ) {
                      this.currentServiceOrder.responsibleName =
                        this.currentUser.name
                    }

                    sessionStorage.clear()
                    Vue.$globalEvent.$emit('loader', false)
                  } catch (error) {
                    Vue.$globalEvent.$emit('loader', false)
                  }
                } else {
                  this.$toast.success('Ordem de serviço adicionada!')
                  setTimeout(() => {
                    this.$router.push('editServiceOrder/' + response.content.id)
                    location.reload()
                  }, 200)
                }
              }

              if (
                this.currentServiceOrder.serviceOrderType == 'Preventiva' &&
                this.templateItems.length > 0
              ) {
                const checklistServiceOrder = {
                  ServiceOrderId: response.content.id,
                  TemplateItems: this.templateItems,
                }

                this.apiService
                  .post('checklistServiceOrder/add', checklistServiceOrder)
                  .then((response) => {})
              }
            })
            .catch((err) => {
              window.scrollTo(0, 0)
              this.errorMessage = err.message
              this.error = true

              setTimeout(() => {
                this.error = false
              }, 4000)
            })
        }
      } else {
        this.$refs.firstForm.$el.scrollIntoView({ behavior: 'smooth' })
        this.$refs.formSupplier.validate()

        this.$nextTick(() => {
          if (!this.formValid) {
            const inputEl = this.$refs.supplierInput.$el.querySelector('input')
            if (inputEl) {
              inputEl.scrollIntoView({ behavior: 'smooth', block: 'center' })
              inputEl.focus()
            }
          }
        })
        this.requestDateTimeError = this.requestDateTime == null
      }

      this.loading = false
      this.changedData = false
    },

    async sendMailOpenServiceOrder() {
      if (this.currentCalled != null) {
        await this.apiService
          .post('called/sendMailServiceOrder', this.currentCalled)
          .then((response = {}))
      }
    },

    async deleteSelection() {
      this.loading = true
      let url = ''
      let data = {}

      if (this.deleteService) {
        url = 'service/delete'
        data = this.currentService
      }

      if (this.deleteDowntime) {
        url = 'machineDowntime/delete'
        data = this.currentMachineDowntime
      }

      if (this.deleteCost) {
        url = 'serviceOrderCost/delete'
        data = this.currentServiceCost
      }

      await this.apiService
        .post(url, data)
        .then(() => {
          this.deleteService = false
          this.deleteDowntime = false
          this.deleteCost = false
          this.getServices()
          this.getServiceOrderCosts()
          this.getMachineDowntimes()
          this.getTotalCost()
          this.removeDialog = false
          this.loading = false
        })
        .catch((err) => {
          window.scrollTo(0, 0)
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async cancelClosing() {
      this.cancelClosingLoading = true

      const serviceOrder = {
        Id: this.currentServiceOrder.id,
        CloseServiceOrderDateTime: null,
        EmailForEvaluation: null,
        RatingServiceCompleted: null,
        RatingServiceTime: null,
        isExecutingSigned: false,
        ExecutingUserId: null,
      }

      await this.apiService
        .post('serviceOrder/closeServiceOrder', serviceOrder)
        .then(() => {
          this.$router.go()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.cancelClosingLoading = false
    },

    async remove() {
      this.loading = true

      const serviceOrderId = this.currentServiceOrder.id

      const model = {
        serviceOrderId: serviceOrderId,
        archivedByuserId: this.currentUser.id,
      }
      await this.apiService
        .delete(`serviceOrder/delete`, model)
        .then((response) => {
          if (response.statusCode == 200) {
            this.$toast.success(this.$t(response.message))
            this.$router.push('/serviceOrders')
          }
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.loading = false
      this.deleteDialog = false
    },

    setRequestNowDate() {
      this.requestDateTime = !this.requestDateTime
        ? new Date()
        : this.requestDateTime
    },

    setAttendNowDate() {
      this.attendDateTime = !this.attendDateTime
        ? new Date()
        : this.attendDateTime
    },

    exitAuthorization() {
      sessionStorage.setItem(
        'serviceOrder',
        JSON.stringify(this.currentServiceOrder)
      )
      const routeData = this.$router.resolve({
        path: '/exitAuthorization',
      })
      window.open(routeData.href, '_blank')
    },

    formatDateTime(date) {
      if (!date) return
      return Utils.dateTime(date)
    },

    formatDate(date) {
      return Utils.moment(date)
    },

    parseDate(date) {
      if (!date) return null

      const dateTimeSplit = date.split(' ')

      const [day, month, year] = dateTimeSplit[0].split('/')
      const time = dateTimeSplit[1]

      if (time) {
        return `${year}-${month.padStart(2, '0')}-${day.padStart(
          2,
          '0'
        )} ${time}:00`
      }

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatInitialDate(dateInitial) {
      const date = new Date(dateInitial),
        day = date.getDate().toString(),
        dayF = day.length == 1 ? '0' + day : day,
        month = (date.getMonth() + 1).toString(),
        monthF = month.length == 1 ? '0' + month : month,
        yearF = date.getFullYear()
      return `${dayF}-${monthF}-${yearF}`
    },

    async querySelectionsEquipment(value) {
      if (this.isEditing) return

      this.equipmentLoading = true

      setTimeout(() => {
        this.equipmentsFiltered = this.equipments.filter((e) => {
          return e.identification.indexOf(value) > -1
        })

        this.equipmentLoading = false
        if (this.equipmentId) {
          this.getEquipmentById()
        }
      }, 500)
    },

    async querySelectionsEquipments(value) {
      if (this.isEditing) return

      this.equipmentLoading = true

      this.equipmentsFiltered = this.equipments.filter((e) => {
        if (e.propertyCode != null) {
          return e.propertyCode.indexOf(value) > -1
        }
      })

      this.equipmentLoading = false
      if (this.equipmentId) {
        this.getEquipmentById()
      }
    },

    async getEquipmentById() {
      if (this.equipmentId) {
        await this.apiService
          .get(
            `equipment/${this.institutionId}/${this.equipmentId}`,
            null,
            true,
            false
          )
          .then((response) => {
            this.equipmentSelected = response.content
            this.unidadeId = response.content.unidadeId
            this.currentServiceOrder.equipment = this.equipmentSelected
            if (response.content.costCenterId != null) {
              this.costCenterId = response.content.costCenterId
              this.costCenterName = response.content.costCenter.name
            }
          })
      }
      await this.getDepartment()
      await this.getChecklistTemplate()
      this.getCostCenter()
    },

    async getDepartment() {
      this.departmentId = this.currentServiceOrder.departmentId
        ? this.currentServiceOrder.departmentId
        : this.equipmentSelected.departmentId
      this.currentServiceOrder.subDepartmentId =
        this.equipmentSelected.subDepartmentId
      await this.apiService
        .get(`department/${this.departmentId}`, null, true, false)
        .then((response) => {
          this.departmentName = response.content.name
        })
    },

    getCostCenter() {
      if (this.costCenterId == null) {
        const costCenter = this.costCenters.find(
          (x) => x.departmentId === this.equipmentSelected.departmentId
        )
        if (costCenter) {
          this.costCenterId = costCenter.id
          this.costCenterName = costCenter.name
        }
      }
    },

    async querySelectionsEquipmentSerial(value) {
      if (this.isEditing) return

      this.equipmentLoading = true

      setTimeout(() => {
        this.equipmentsFiltered = this.equipments.filter((e) => {
          return e.serialNumber && e.serialNumber.indexOf(value) > -1
        })

        this.equipmentLoading = false
        if (this.equipmentId) {
          this.getEquipmentById()
        }
      }, 500)
    },
  },

  watch: {
    equipmentId(nv) {
      const equip = this.equipments.find((x) => x.id == nv)
      if (equip) {
        const isInWarranty = moment().isBefore(
          moment(equip.warrantyEndDate, 'yyyy-MM-DD')
        )
        if (isInWarranty) {
          this.$toast('O equipamento selecionado está na garantia!')
        }
      }
    },

    searchEquipmentSerial(value) {
      value &&
        value !== this.equipmentId &&
        this.querySelectionsEquipmentSerial(value)
    },

    unidadeId() {
      if (this.unidadeId) {
        this.getDepartments()
        this.getCostCenters()
      }
    },

    currentServiceOrder: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },

    requestDateTime: {
      deep: true,
      handler() {
        this.changedData = true
        this.requestDateTimeError = false
      },
    },

    attendDateTime: {
      deep: true,
      handler() {
        this.changedData = true
        this.attendDateTimeError = false
      },
    },

    searchEquipment(value) {
      value &&
        value !== this.equipmentId &&
        this.querySelectionsEquipment(value)
    },

    searchEquipmentPropertyCode(value) {
      value &&
        value !== this.equipmentId &&
        this.querySelectionsEquipments(value)
    },
    'currentServiceOrder.id'(newId) {
      if (newId > 0) {
        this.getTotalCost()
      }
    },
  },
}
